import React from 'react';
import {
  BottomSection,
  ListTitle,
  ListSection,
  BorderDiv,
  ListBottomSection,
  ProjectDiv,
  Status,
  ProjectName
} from '../styles';
import { observer } from 'mobx-react-lite';

const RightSectionLoading = () => {
  return (
    <>
      <BottomSection>
        <ListSection>
          <ListTitle />
          <BorderDiv />
          <ListBottomSection>
            <ProjectDiv>
              <Status></Status>
              <ProjectName />
            </ProjectDiv>
            <ProjectDiv>
              <Status></Status>
              <ProjectName className='w-390' />
            </ProjectDiv>
            <ProjectDiv>
              <Status></Status>
              <ProjectName className='w-280' />
            </ProjectDiv>
            <ProjectDiv>
              <Status></Status>
              <ProjectName className='w-170' />
            </ProjectDiv>
          </ListBottomSection>
        </ListSection>
        <ListSection>
          <ListTitle />
          <BorderDiv />
          <ListBottomSection>
            <ProjectDiv>
              <Status></Status>
              <ProjectName />
            </ProjectDiv>
            <ProjectDiv>
              <Status></Status>
              <ProjectName className='w-170' />
            </ProjectDiv>
            <ProjectDiv>
              <Status></Status>
              <ProjectName className='w-280' />
            </ProjectDiv>
            <ProjectDiv>
              <Status></Status>
              <ProjectName className='w-390' />
            </ProjectDiv>
          </ListBottomSection>
        </ListSection>
        <ListSection>
          <ListTitle />
          <BorderDiv />
          <ListBottomSection>
            <ProjectDiv>
              <Status></Status>
              <ProjectName />
            </ProjectDiv>
            <ProjectDiv>
              <Status></Status>
              <ProjectName className='w-170' />
            </ProjectDiv>
            <ProjectDiv>
              <Status></Status>
              <ProjectName className='w-280' />
            </ProjectDiv>
            <ProjectDiv>
              <Status></Status>
              <ProjectName className='w-390' />
            </ProjectDiv>
          </ListBottomSection>
        </ListSection>
      </BottomSection>
    </>
  );
};

export default observer(RightSectionLoading);
